var _excluded = ["size", "color", "style", "className", "spin", "rotate"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FoxIconLoading02Core = function FoxIconLoading02Core(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    role: "img"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M987.989333 548.010667a35.968 35.968 0 0 1-35.968-36.010667c0-59.392-11.605333-116.992-34.602666-171.306667a440.490667 440.490667 0 0 0-94.293334-139.904A437.674667 437.674667 0 0 0 512 71.978667 35.968 35.968 0 1 1 512 0c69.12 0 136.192 13.482667 199.296 40.32 61.013333 25.685333 115.712 62.72 162.688 109.653333a511.146667 511.146667 0 0 1 109.696 162.730667c26.709333 63.104 40.234667 130.176 40.234667 199.296a35.84 35.84 0 0 1-35.925334 36.010667z"
    })
  }));
};
var Memo = /*#__PURE__*/memo(FoxIconLoading02Core);
/**
 * ![FoxIconLoading02](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCI+PHBhdGggZD0iTTk4Ny45ODkzMzMgNTQ4LjAxMDY2N2EzNS45NjggMzUuOTY4IDAgMCAxLTM1Ljk2OC0zNi4wMTA2NjdjMC01OS4zOTItMTEuNjA1MzMzLTExNi45OTItMzQuNjAyNjY2LTE3MS4zMDY2NjdhNDQwLjQ5MDY2NyA0NDAuNDkwNjY3IDAgMCAwLTk0LjI5MzMzNC0xMzkuOTA0QTQzNy42NzQ2NjcgNDM3LjY3NDY2NyAwIDAgMCA1MTIgNzEuOTc4NjY3IDM1Ljk2OCAzNS45NjggMCAxIDEgNTEyIDBjNjkuMTIgMCAxMzYuMTkyIDEzLjQ4MjY2NyAxOTkuMjk2IDQwLjMyIDYxLjAxMzMzMyAyNS42ODUzMzMgMTE1LjcxMiA2Mi43MiAxNjIuNjg4IDEwOS42NTMzMzNhNTExLjE0NjY2NyA1MTEuMTQ2NjY3IDAgMCAxIDEwOS42OTYgMTYyLjczMDY2N2MyNi43MDkzMzMgNjMuMTA0IDQwLjIzNDY2NyAxMzAuMTc2IDQwLjIzNDY2NyAxOTkuMjk2YTM1Ljg0IDM1Ljg0IDAgMCAxLTM1LjkyNTMzNCAzNi4wMTA2Njd6Ij48L3BhdGg+PC9zdmc+) 
 **/
export default function FoxIconLoading02(_ref) {
  var size = _ref.size,
    color = _ref.color,
    style = _ref.style,
    className = _ref.className,
    spin = _ref.spin,
    rotate = _ref.rotate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var svgStyle = React.useMemo(function () {
    return rotate ? {
      msTransform: "rotate(".concat(String(rotate), "deg)"),
      transform: "rotate(".concat(String(rotate), "deg)")
    } : undefined;
  }, [rotate]);
  var customStyle = React.useMemo(function () {
    var tmp = {};
    if (size !== undefined) {
      tmp.fontSize = size;
    }
    if (color !== undefined) {
      tmp.color = color;
    }
    return tmp;
  }, [size, color, rotate]);
  var realStyle = React.useMemo(function () {
    if (style) {
      return _objectSpread(_objectSpread({}, customStyle), style);
    }
    return customStyle;
  }, [style, customStyle]);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    role: "img",
    className: classNames("appicon app_icon", className, spin ? "appicon-spin" : ""),
    style: realStyle
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Memo, {
      style: svgStyle
    })
  }));
}